import { BpiGetCategoriesResponse, BpiGetCategoryDetailsResponse } from "../entities/BpiEntities";
import { executeGet } from "./ServiceHelper";

export function getCategories(): Promise<BpiGetCategoriesResponse> {
    return executeGet<BpiGetCategoriesResponse>("api/bpi/categories");
};

export function getCategoryDetails(code: string): Promise<BpiGetCategoryDetailsResponse> {
    return executeGet<BpiGetCategoryDetailsResponse>("api/bpi/categoryDetails?code=" + code);
}